import { OrgAdminLayout } from '@/components/organisms/org-admin';
import './styles/org-admin-tokens.css';

export function OrgAdminPage() {
  return (
    <div className="flex h-full min-h-0 flex-col bg-background">
      <OrgAdminLayout />
    </div>
  );
}

export default OrgAdminPage;
